import { useEffect, useRef } from 'react';

const useComandaPolling = (comandaId, onComandaUpdate, enabled = true) => {
  const intervalRef = useRef(null);
  const lastUpdateRef = useRef(null);

  // Função para obter brand baseado no subdomínio (igual ao App.js)
  const getBrand = () => {
    const host = window.location.host;
    const parts = host.split('.');
    return parts[0].includes('localhost') ? 'gente-bonita' : parts[0];
  };

  const startPolling = () => {
    if (!comandaId) {
      return;
    }

    const poll = async () => {
      try {
        const brand = getBrand();
        const url = `https://lucifer.grub.digital/public/comanda/${brand}/${comandaId}/polling`;
        
        const response = await fetch(url, {
          headers: {
            'Content-Type': 'application/json'
          }
        });

        if (response.ok) {
          const data = await response.json();
          
          // Verificar se houve mudança
          const currentUpdate = JSON.stringify(data);
          if (currentUpdate !== lastUpdateRef.current) {
            lastUpdateRef.current = currentUpdate;
            if (onComandaUpdate) {
              onComandaUpdate(data);
            }
          }
        }
      } catch (error) {
        // Erro silencioso para evitar spam no console
      }
    };

    // Fazer primeira busca imediatamente
    poll();

    // Configurar polling a cada 5 segundos (reduzido para menos requisições)
    intervalRef.current = setInterval(poll, 5000);
  };

  const stopPolling = () => {
    if (intervalRef.current) {
      clearInterval(intervalRef.current);
      intervalRef.current = null;
    }
    lastUpdateRef.current = null;
  };

  useEffect(() => {
    if (comandaId && enabled) {
      startPolling();
    } else {
      stopPolling();
    }

    return () => {
      stopPolling();
    };
  }, [comandaId, enabled]);

  return {
    isConnected: !!intervalRef.current,
    disconnect: stopPolling
  };
};

export default useComandaPolling;